<div class="p-d-flex p-jc-between p-ai-start">
  <h1 class="page-title">{{ "Todo.Title" | translate }}</h1>
  <div class="display-category-toggle">
    <a
      [ngClass]="{
        'display-category-toggle-button': true,
        active: currentDisplayType === displayTypes.GRID
      }"
      (click)="changeDisplayType(displayTypes.GRID)"
    >
      <i class="pi pi-grid"></i>
    </a>
    <a
      [ngClass]="{
        'display-category-toggle-button': true,
        active: currentDisplayType === displayTypes.LIST
      }"
      (click)="changeDisplayType(displayTypes.LIST)"
    >
      <i class="pi pi-list"></i>
    </a>
  </div>
</div>

<p-tabView styleClass="p-tabview-todo">
  <p-tabPanel>
    <ng-template pTemplate="header">
      <span>{{ "Todo.Index.OwnJob" | translate }}</span>
      <p-badge [value]="getAllProcessesCount(TodoResponsibility.OWN)"></p-badge>
    </ng-template>
    <ng-template pTemplate="content">
      <p-accordion
        [multiple]="true"
        expandIcon="pi pi-fw pi-collapse-open"
        collapseIcon="pi pi-fw pi-collapse-close"
        styleClass="no-border"
      >
        <ng-container *ngFor="let todo of ownTodos$ | async">
          <p-accordionTab *ngIf="todo.processes.length > 0"
            [header]="todo.companyName"
            [selected]="true"
          >
            <div class="p-grid">
              <ng-template
                ngFor
                let-todoProcess
                [ngForOf]="todo.processes"
                let-index="index"
              >
                <a
                  *ngFor="let task of todoProcess.tasks"
                  [class]="currentDisplayType === DisplayType.GRID ? 'p-col-4' : 'p-col-12'"
                  (click)="
                    redirectToPage(
                      $event,
                      todo.companyId,
                      todoProcess.systemCode,
                      todoProcess.processDefKey,
                      task.taskDefKey,
                      false
                    )
                  "
                >
                  <div
                    class="card"
                    [ngClass]="{
                      card: true,
                      horizontal: currentDisplayType === displayTypes.LIST
                    }"
                  >
                    <div class="card-header">
                      {{ todoProcess.processName }}
                    </div>
                    <div class="card-content" ng-controller="AlbumCtrl">
                      {{ task.taskName }}
                    </div>
                    <div
                      [ngClass]="[
                        'card-badge',
                        getBadgeStatusClassName(task.count)
                      ]"
                    >
                      {{ task.count | counterMaximum }}
                    </div>
                  </div>
                </a>
              </ng-template>
            </div>
          </p-accordionTab>
        </ng-container>
      </p-accordion>
    </ng-template>
  </p-tabPanel>

  <p-tabPanel>
    <ng-template pTemplate="header">
      <span>{{ "Todo.Index.Substitute" | translate }}</span>
      <p-badge [value]="getAllProcessesCount(TodoResponsibility.SUB)"></p-badge>
    </ng-template>
    <ng-template pTemplate="content">
      <p-accordion
        [multiple]="true"
        expandIcon="pi pi-fw pi-collapse-open"
        collapseIcon="pi pi-fw pi-collapse-close"
        styleClass="no-border"
      >
        <ng-container *ngFor="let todo of subTodos$ | async">
          <p-accordionTab *ngIf="todo.processes.length > 0"
            [header]="todo.companyName"
            [selected]="true"
          >
            <div class="p-grid">
              <ng-template
                ngFor
                let-todoProcess
                [ngForOf]="todo.processes"
                let-index="index"
              >
                <a
                  *ngFor="let task of todoProcess.tasks"
                  [class]="currentDisplayType === DisplayType.GRID ? 'p-col-4' : 'p-col-12'"
                  (click)="
                    redirectToPage(
                      $event,
                      todo.companyId,
                      todoProcess.systemCode,
                      todoProcess.processDefKey,
                      task.taskDefKey,
                      true
                    )
                  "
                >
                  <div
                    class="card"
                    [ngClass]="{
                      card: true,
                      horizontal: currentDisplayType === displayTypes.LIST
                    }"
                  >
                    <div class="card-header">
                      {{ todoProcess.processName }}
                    </div>
                    <div class="card-content" ng-controller="AlbumCtrl">
                      {{ task.taskName }}
                    </div>
                    <div
                      [ngClass]="[
                        'card-badge',
                        getBadgeStatusClassName(task.count)
                      ]"
                    >
                      {{ task.count | counterMaximum }}
                    </div>
                  </div>
                </a>
              </ng-template>
            </div>
          </p-accordionTab>
        </ng-container>

      </p-accordion>
    </ng-template>
  </p-tabPanel>
</p-tabView>
